/**
 * Pushes flow context to dataLayer for analytics: A/B version, flow name, and UTM parameters.
 * Ensures GTM/GA can access the same values as Redux and database.
 */
import { resolveUtmParams } from './utmBootstrap';

export function pushFlowContextToDataLayer({ version, flow, company_store }) {
	if (typeof window === 'undefined' || !window.dataLayer) return;

	const utm = resolveUtmParams({ company_store });
	const payload = {
		event: 'sf_step_A/B_testing',
		version: version || 'A',
		event_category: flow || 'aspflow',
		flow: flow || 'aspflow',
		ab_version: version || 'A',
		...utm,
	};

	window.dataLayer.push(payload);
}
